"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$lines = void 0;
const factory_1 = __importDefault(require("../factory"));
const _blankLine_1 = __importDefault(require("./$blankLine"));
const _tocHeadLine_1 = __importDefault(require("./$tocHeadLine"));
const _articleGroupHeadLine_1 = __importDefault(require("./$articleGroupHeadLine"));
const _appdxItemHeadLine_1 = __importDefault(require("./$appdxItemHeadLine"));
const _supplProvisionAppdxItemHeadLine_1 = __importDefault(require("./$supplProvisionAppdxItemHeadLine"));
const _supplProvisionHeadLine_1 = __importDefault(require("./$supplProvisionHeadLine"));
const _articleLine_1 = __importDefault(require("./$articleLine"));
const _paragraphItemLine_1 = __importDefault(require("./$paragraphItemLine"));
const _tableColumnLine_1 = __importDefault(require("./$tableColumnLine"));
const _otherLine_1 = __importDefault(require("./$otherLine"));
exports.$lines = factory_1.default.withName("lines")
    .sequence(s => s
    .and(r => r
    .zeroOrMore(r => r
    .choice(c => c
    .or(() => _blankLine_1.default)
    .or(() => _tableColumnLine_1.default)
    .or(() => _tocHeadLine_1.default)
    .or(() => _articleGroupHeadLine_1.default)
    .or(() => _paragraphItemLine_1.default)
    .or(() => _supplProvisionHeadLine_1.default)
    .or(() => _supplProvisionAppdxItemHeadLine_1.default)
    .or(() => _appdxItemHeadLine_1.default)
    .or(() => _articleLine_1.default)
    .or(() => _otherLine_1.default))), "lines")
    .action(({ lines }) => {
    return {
        value: lines.map(line => line.value),
        errors: lines.map(line => line.errors).flat(),
    };
}));
exports.default = exports.$lines;
//# sourceMappingURL=$lines.js.map